import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ServiceProfileContainer.less";
import moment from "moment";
import ServiceProfile from "../../components/ServiceProfile/ServiceProfile";
import {
  fetchInvoicePeriodStatus,
  fetchPaymentTypeStatus,
  fetchPrePaymentPeriodStatus,
  fetchProfileTypeStatus,
} from "../../store/slices/rtkDictionaries";
import { fetchServiceProfiles } from "../../store/slices/service-profile";
import { toHttpFormatStartOfDay } from "../../lib/utils/formatDate";
import { buildQueryStringWithObjectParams } from "../../lib/utils";

const ServiceProfileContainer = () => {
  const dispatch = useDispatch();
  const dateNow = toHttpFormatStartOfDay(moment());
  const [findProfilesByDate, setFindProfilesByDate] = useState(false);

  const [serviceProfilesParams, setServiceProfilesParams] = useState({
    onDate: dateNow,
    profileType: "common",
  });

  const queryStringServiceProfiles = `&${buildQueryStringWithObjectParams(serviceProfilesParams)}`;

  const { serviceProfiles, serviceProfilesLoading } = useSelector((state) => state.serviceProfile);
  const {
    profileTypeStatus,
    profileTypeStatusLoading,
    invoicePeriodStatus,
    invoicePeriodStatusLoading,
    prePaymentPeriodStatus,
    prePaymentPeriodStatusLoading,
    paymentTypeStatus,
    paymentTypeStatusLoading,
  } = useSelector((state) => state.rtkDictionaries);

  useEffect(() => {
    dispatch(fetchProfileTypeStatus());
    dispatch(fetchInvoicePeriodStatus());
    dispatch(fetchPrePaymentPeriodStatus());
    dispatch(fetchPaymentTypeStatus());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(fetchServiceProfiles({ queryString: queryStringServiceProfiles }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [findProfilesByDate]);

  const onChangeDateProfiles = (e) => {
    setServiceProfilesParams({
      ...serviceProfilesParams,
      onDate: e ? toHttpFormatStartOfDay(e) : "",
    });
  };

  return (
    <>
      <div className="container_height">
        <ServiceProfile
          serviceProfiles={serviceProfiles}
          serviceProfilesLoading={serviceProfilesLoading}
          profileTypeStatus={profileTypeStatus}
          profileTypeStatusLoading={profileTypeStatusLoading}
          invoicePeriodStatus={invoicePeriodStatus}
          invoicePeriodStatusLoading={invoicePeriodStatusLoading}
          prePaymentPeriodStatus={prePaymentPeriodStatus}
          prePaymentPeriodStatusLoading={prePaymentPeriodStatusLoading}
          paymentTypeStatus={paymentTypeStatus}
          paymentTypeStatusLoading={paymentTypeStatusLoading}
          onChangeDateProfiles={onChangeDateProfiles}
          setFindProfilesByDate={setFindProfilesByDate}
          queryStringServiceProfiles={queryStringServiceProfiles}
        />
      </div>
    </>
  );
};

export default ServiceProfileContainer;
